import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { API_BACKEND_URL } from "../Config/Config";

const getUserDetails = () => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  return JSON.parse(userDetails);
};

const deleteChain = async ({ chainId }) => {
  const user = getUserDetails();
  const response = await axios.delete(
    `${API_BACKEND_URL}/chains/deleteChain?companyId=${user.companyid}&chainId=${chainId}`,
  );
  return response.data;
};

export const useDeleteApiChain = (options = {}) => {
  return useMutation({
    mutationFn: deleteChain,
    ...options,
  });
};


//Create a chain manually

const createApiChain = async({data}) => {
  const user = getUserDetails();

  const response  = await axios.post(`
    ${API_BACKEND_URL}/chains/add?companyId=${user.companyid}`,
    data

  )
  return response.data;
}


export const useCreateApiChain = (options = {}) => {
  return useMutation({
    mutationFn: createApiChain,
    ...options,
  });
};


const deleteTcFromChain = async({tcId}) => {
  const user = getUserDetails();
  const response = await axios.delete(
    `${API_BACKEND_URL}/chains/deleteChainCases/${tcId}?companyId=${user.companyid}`,
  )
  return response.data;
}

export const useDeleteTcFromChain = (options = {}) => {
  return useMutation({
    mutationFn: deleteTcFromChain,
    ...options,
  });
};